module.exports = __webpack_public_path__ + "media/images/potatoes-9e302979febb6eeb90711efd1a8e63f8.png";